<template>
  <div class=" margin-top-30 footer">
    <!-- <div style="width: 100%" class="flex "> -->
      <!-- <img src="../assets/images/footer_back_new.jpg" alt=""> -->
      <!-- <template v-if="isShengzheng"> -->
        <!--      中文-->
        <!-- <div class="flex"
             v-if="!g.isEn"
             style="width: 100%;max-width: 1098px;margin: auto;justify-content: space-between;padding-left: 20px;padding-right: 20px;">
          <div class="flex">
            <div style="margin-right: 30px">
              <div style="font-size: 16px;font-weight: 600;margin-bottom: 15px;">{{$t('lang.展会主办单位')}}：闻信展览</div>
              <div style="margin-bottom: 10px;">{{$t('lang.深圳办公室')}}</div>
              <div style="margin-bottom: 10px;">86&nbsp;755&nbsp;2691&nbsp;7607</div>
              <div style="margin-bottom: 10px;">led-trust.cn@informa.com</div>
            </div>
            <div style="margin-right: 30px;position: relative;top: 30px">
              <div style="margin-bottom: 10px;">{{$t('lang.广州办公室')}}</div>
              <div style="margin-bottom: 10px;">86&nbsp;20&nbsp;3810&nbsp;6261</div>
              <div>www.LEDChina.com</div>
            </div>
            <div style="position: relative;top: 30px">
              <div style="margin-bottom: 10px;">{{$t('lang.上海办公室')}}</div>
              <div>86&nbsp;21&nbsp;6162&nbsp;&nbsp;3716</div>
            </div>
          </div>

          <div class="flex">
            <div style="width: 112px;height: 112px;margin-right: 20px;display: flex;align-items: center">
              <img src="../assets/images/22222.png" alt="" style="
        max-width:100%;
        max-height:100%;
        "/>
            </div>
            <div style="width: 112px;height: 112px;margin-left: 20px;">
              <img src="../assets/images/erwm.png" alt="" style="
        max-width:100%;
        max-height:100%;
        "/>
            </div>
          </div>
        </div> -->
        <!--      英文-->
        <!-- <div class="flex"
             v-else
             style="width: 100%;max-width: 1270px;margin: auto;justify-content: space-between;padding-left: 20px;padding-right: 20px;">
          <div class="flex">
            <div style="width:500px;margin-right: 30px;display: flex;align-items: center;">
              <img src="https://picture-coolgua.oss-cn-shenzhen.aliyuncs.com/主办logo2.png?versionId=CAEQJBiBgICrlsntyhciIDI4N2EzZTkxMTU4YjQyZDViNjVkMzRlNmU0MWVlYjNi" alt="" style="
        max-width:100%;
        max-height:100%;
        "/>
            </div>
            <div style="margin-right: 30px;position: relative;top: 30px;font-size:18px;">
              <div style="margin-bottom: 10px;">Tel: +86 20 8327 6369/6389</div>
              <div style="margin-bottom: 10px;">E-mail: vcc@unifair.com</div>
            </div>
            <div style="position: relative;top: 30px">
              <div style="margin-bottom: 10px;">Shanghai office</div>
              <div>86&nbsp;21&nbsp;61576&nbsp;3915</div>
            </div>
          </div>
          <div class="flex">
            <div style="width: 100px;height: 100px;margin-right: 20px;display: flex;align-items: center;">
              <img src="https://picture-coolgua.oss-cn-shenzhen.aliyuncs.com/二维码0525.png?versionId=CAEQJBiBgIDsy_fCzRciIDIxYWMyNTc0MjgzZDQyYzA5OTM5NGUwMmNmZGE5MDRi" alt="" style="
        max-width:100%;
        max-height:100%;
        "/>
            </div>
          </div>
        </div>
      </template>
    </div> -->
    <!--    免责声明-->
    <!-- <div style="max-width: 1200px;margin: auto;margin-top: 20px;font-size:14px;">
      <div v-if="g.isEn" style="line-height: 22px;">
        The Organizers provide this online platform for exhibitors and visitors to participate at VIRTUAL CERAMIC CONNECT. Information presented on this platform is solely based on information provided by exhibitors and visitors.The Organizers are not responsible for the authenticity and the accuracy of above mentioned information and contents.
      </div>
      <div v-else style="line-height: 18px;">
        此平台是大会主办方闻信展览为采购商，参展商及合作伙伴所提供的线上展览服务平台。此平台所呈现的采购商，采购需求，参展商及参展展品内容，均基于采购商与参展商自主自愿提供的信息；合作伙伴所提供的内容只代表合作伙伴的立场。大会主办方闻信展览对上述内容的真实性、准确性不承担任何责任。
      </div>-->

    <!-- </div> -->


    <!-- <h1 class="footer-title">{{$t('lang.联系我们')}}</h1>
    <h1 class="footer-title">{{$t('lang.中国纺织品商业协会')}}</h1>
    <p class="contacts">
      <span>{{$t('lang.联系人')}}：刘志理</span>
      <span>{{$t('lang.联系人')}}：李智</span>
      <span>{{$t('lang.联系人')}}：刘鑫</span>
    </p>
    <p class="phoneNum">
      <span>{{$t('lang.联系电话')}}：18500040917</span>
      <span>{{$t('lang.联系电话')}}：18611138755</span>
      <span>{{$t('lang.联系电话')}}：13301029797</span>
    </p>
    <template v-if="isEn">
      <p class="copyright">Copyright ©2019 CIOSH Asia Co., Ltd. All Rights Reserved. 京ICP备05021274号</p>
    </template>
    <template v-else>
      <p class="copyright">版权所有©️中国劳动保护用品交易会&nbsp;&nbsp;&nbsp;&nbsp;中国纺织品商业协会</p>
      <p class="copyright">京ICP备4022569号-7</p>
    </template>
    
    <div class="qrcode">
      <img src="../assets/images/qrcode1.jpg" alt="">
      <img src="../assets/images/qrcode2.jpg" alt="">
    </div> -->
    <div style="width:100%;position: relative;">
      <img style="width:100%;" src="https://coolgua-dev.oss-cn-beijing.aliyuncs.com/底部信息栏.jpg" alt="">
      <div style="position: absolute;top: 50%;transform: translateY(-50%);right: 50px;width: 100px;">
        <img style="width: 100px;height: 100px;" src="../assets/images/mini-logo.jpg" alt="">
        <p style="margin-top:10px;font-size: 14px;font-weight: bold;">云上西部文博会</p>
    </div>
    </div>
  </div> 
</template>
<script>
  import { isShengzheng } from "../constants";

  export default {
    data() {
      const lang = sessionStorage.getItem('lang') || 'zh';

      return {
        isEn: lang === 'en',
        isShengzheng: isShengzheng
      }
    },
  }
</script>
<style scoped lang="less">
  .footer {
    position: relative;
    // padding: 20px;
    color: #fff;
    font-size: 14px;
    // background-color:rgba(154, 157, 151, 1);
    .footer-title {
      & + .footer-title {
        margin-top: 30px;
      }
      padding-left: 20px;
      font-size: 18px;
      font-weight: bold;
    }
    .contacts {
      margin-top: 15px;
      padding-left: 20px;
      span {
        display: inline-block;
        width: 250px;
      }
    }
    .phoneNum {
      margin-top: 20px;
      padding-left: 20px;
      span {
        position: relative;
        display: inline-block;
        width: 250px;
        &::after {
        content: '';
        position: absolute;
        top: 50%;
        right: 65px;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
        background: url('../assets/images/phone.png') center center no-repeat;
        background-size: 100% 100%;
      }
      }
    }
    .copyright {
      & + .copyright {
        margin-top: 15px;
      }
      margin-top: 60px;
      text-align: center;
    }
    .qrcode {
      position: absolute;
      top: 30px;
      right: 50px;
      img {
        display: inline-block;
        margin-right: 50px;
        width: 120px;
        height: 120px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/wenxing/components/mfooter.vue